import React, { lazy, useEffect } from 'react'
import './App.css'
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import { themeChange } from 'theme-change'
import initializeApp from './app/init'
import { isTokenExpired } from './utils/isTokenExpired'


const Layout = lazy(() => import('./containers/Layout'))
const Login = lazy(() => import('./features/user/Login'))
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'))
const Documentation = lazy(() => import('./pages/Documentation'))

initializeApp()

function clearAuthStorage() {
  localStorage.removeItem("token")
  localStorage.removeItem("user")
  localStorage.removeItem("role")
  localStorage.removeItem("role_id")
  localStorage.removeItem("permissions")
  localStorage.removeItem("last_activity")
}

function ProtectedRoute({ children }) {
  const token = localStorage.getItem("token")

  if (!token || isTokenExpired(token)) {
    clearAuthStorage()
    return <Navigate to="/login" replace />
  }

  return children
}

function App() {
  useEffect(() => {
    themeChange(false)
  }, [])

  const token = localStorage.getItem("token")
  const isLoggedIn = token && !isTokenExpired(token)

  if (token && isTokenExpired(token)) {
    clearAuthStorage()
  }

  return (
    <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/documentation" element={<Documentation />} />

          <Route
            path="/app/*"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          />

          <Route
            path="*"
            element={
              isLoggedIn
                ? <Navigate to="/app/dashboard" replace />
                : <Navigate to="/login" replace />
            }
          />
        </Routes>
      </Router>
  )
}

export default App